/*
 * Handles <details>-based drill-down inside desktop mega menus.
 * On mobile, MenuDrawer (global.js) handles everything automatically
 * because it binds to all <summary> and <button> elements in the drawer.
 * This script only covers the desktop mega-menu context.
 */
// Temporary debug helper — call lockMegaMenu() from console to keep it open
window.lockMegaMenu = function () {
  document.querySelectorAll('animated-details').forEach(function (ad) {
    ad.close = function () {};
  });
  console.log('Mega menu locked open — close() disabled on all animated-details');
};

document.addEventListener('DOMContentLoaded', function () {
  // Back buttons inside mega-menu-content (desktop context only)
  document.addEventListener('click', function (e) {
    var backBtn = e.target.closest('.mega-menu-content .menu-drawer-parent-button');
    if (backBtn) {
      var details = backBtn.closest('details');
      if (details) {
        var summary = details.querySelector('summary');
        details.removeAttribute('open');
        if (summary) summary.focus();
      }
    }
  });

  // Reset all inner <details> when a mega menu closes
  document.querySelectorAll('animated-details').forEach(function (ad) {
    var outer = ad.querySelector('details');
    if (!outer) return;
    outer.addEventListener('toggle', function () {
      if (!outer.open) {
        outer.querySelectorAll('.mega-menu-content details[open]').forEach(function (d) {
          d.removeAttribute('open');
        });
      }
    });
  });
});
